import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "9",
  viewBox: "0 0 16 9",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M7.43853 6.84477L7.78618 7.1811L8.13384 6.84477L13.8084 1.35506L14.3889 1.91667L7.78618 8.30431L1.18347 1.91667L1.76398 1.35506L7.43853 6.84477Z",
      fill: "currentColor",
      stroke: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }